import * as service from './service'
export default {
  namespace: 'courierTaskTaskCenter',
  state: {
    taskCenterInfo: [],
    growTaskSortList: []
  },
  effects: {
    * taskCenterInfo ({ payload }, { call, put }) {
      const res = yield call(service.taskCenterInfo, payload)
      if (res.data.status === 200) {
        if (res.data.data) {
          const current = res.data.data.findIndex(
            (item) => item.activityStatus === 3
          )
          if (current !== -1) {
            res.data.data[
              res.data.data.findIndex((item) => item.activityStatus === 3)
            ].awardTips = true
          }
        }
        yield put({
          type: 'save',
          payload: {
            taskCenterInfo: res.data.data
          }
        })
      }
    },

    * taskCenterV2 ({ payload }, { call, put }) {
      const res = yield call(service.taskCenterV2, payload)
      if (res.data.status === 200) {
        if (res.data.data) {
          if (res.data.data.growTaskList) {
            const current = res.data.data.growTaskList.findIndex(
              (item) => item.activityStatus === 3
            )
            if (current !== -1) {
              res.data.data.growTaskList[
                res.data.data.growTaskList.findIndex(
                  (item) => item.activityStatus === 3
                )
              ].awardTips = true
            }
          }

          yield put({
            type: 'save',
            payload: {
              taskCenterInfo: res.data.data.growTaskList
                ? [...res.data.data.growTaskList]
                : [],
              growTaskSortList: res.data.data.growTaskSortList
                ? [...res.data.data.growTaskSortList]
                : []
            }
          })
          return res.data.data
        }
      }
    },

    * getPackageAward ({ payload }, { call, put }) {
      try {
        const res = yield call(service.getPackageAward, payload)
        const { data, status, err, errMsg } = res.data
        if (status === 200) {
          return data
        } else {
          return Promise.reject()
        }
      } catch (error) {
        return Promise.reject()
      }
    },

    * getSubTaskAward ({ payload }, { call, put }) {
      try {
        const res = yield call(service.getSubTaskAward, payload)
        const { data, status, err, errMsg } = res.data
        if (status === 200) {
          return data
        } else {
          return Promise.reject()
        }
      } catch (error) {
        return Promise.reject()
      }
    },

    * getTodayData ({ payload }, { call, put }) {
      try {
        const res = yield call(service.getTodayData, payload)
        const { data, status, err, errMsg } = res.data
        if (status === 200) {
          return data
        } else {
          return Promise.reject()
        }
      } catch (error) {
        return Promise.reject()
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
